import { toServerString } from './date'

export function optimisticUpdatedAt() {
  const updatedAt = new Date()
  updatedAt.setSeconds(updatedAt.getSeconds())
  return toServerString(updatedAt)
}
